import { useEffect, useMemo, useState } from "react";
import { Container, Stack, Paper, Button } from "@mui/material";

import {
  CardAll,
  ConditionalRenderer,
  DataDisplayMessage,
  Filters,
  Header,
  TabsFilters,
  useLanguageTranslator,
} from "../../../components";
import { usePublicPoliciesCall } from "../../../hooks";

function PoliciesList() {
  const [inputValue, setInputValue] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({
    country: "",
    startYear: "",
    endYear: "",
    theme: "",
    geographicalArea: "",
  });
  const [currTab, setCurrTab] = useState<"all" | any>("all");
  const [limit, setLimit] = useState(8);

  const { translator } = useLanguageTranslator();

  const { policies, tabs, loading, metadata } = usePublicPoliciesCall({
    variables: {
      limit: limit,
      ...(filters?.country && filters?.country !== "0"
        ? { countryId: Number(filters?.country) }
        : {}),
      ...(filters?.theme && filters?.theme !== "0"
        ? { themeId: Number(filters?.theme) }
        : {}),
      ...(filters?.startYear ? { startYear: Number(filters?.startYear) } : {}),
      ...(filters?.endYear ? { endYear: Number(filters?.endYear) } : {}),
      ...(filters?.geographicalArea && filters?.geographicalArea !== "0"
        ? { geographicalAreaId: Number(filters?.geographicalArea) }
        : {}),
    },
    currTab: currTab,
    totalCountItems: totalCount,
  });

  useEffect(() => {
    if (metadata?.totalCount) {
      setTotalCount(metadata?.totalCount);
    }
  }, [metadata]);

  function onClickHandler() {
    const scrollPosition = window.scrollY;
    setLimit(limit + 8);

    setTimeout(() => {
      window.scrollTo(0, scrollPosition);
    }, 0);
  }

  const hasMore =
    limit === metadata?.totalCount ||
    limit > metadata?.totalCount ||
    !metadata?.totalCount;

  const filteredPoliciesList = useMemo(() => {
    if (!inputValue) return policies || [];

    const searchValue = inputValue
      ?.normalize("NFD")
      ?.replace(/[\u0300-\u036f]/g, "")
      ?.toLowerCase();

    return policies?.filter((item: any) =>
      item?.title
        ?.normalize("NFD")
        ?.replace(/[\u0300-\u036f]/g, "")
        ?.toLowerCase()
        ?.includes(searchValue)
    );
  }, [inputValue, policies]);

  return (
    <div>
      <Header
        title={translator("Policies")}
        subtitle=""
        setInputValue={setInputValue}
        inputValue={inputValue}
      />
      <Filters
        setFilters={setFilters}
        filters={filters}
        isPublicPolicies={true}
      />

      <Container sx={{ my: 3 }}>
        <TabsFilters
          currTab={currTab}
          setCurrTab={setCurrTab}
          listItems={tabs}
          heading={`${translator("List of")} ${translator("Policies")}`}
          isAllShow={true}
        />

        <Stack gap={2}>
          {filteredPoliciesList?.map((p: any, i: any) => (
            <CardAll p={p} loading={loading} path={`/policies/${p.id}`} />
          ))}
          <DataDisplayMessage data={filteredPoliciesList} loading={loading} />
        </Stack>
      </Container>

      <ConditionalRenderer condition={!hasMore}>
        <Container sx={{ my: 3 }}>
          <Paper sx={{ py: 2, display: "flex", justifyContent: "center" }}>
            <Button onClick={onClickHandler}>{translator("Show more")}</Button>
          </Paper>
        </Container>
      </ConditionalRenderer>
    </div>
  );
}

export { PoliciesList };
